<template>
	<div class="flex flex-wrap justify-between mt-20">
		<div class="w-auto" v-if="prev">
			<router-link :to="prev" class="flex items-center">
				<span class="nav-arrow rotate-left"></span>
			</router-link>
		</div>

		<div class="w-auto" v-if="next">
			<router-link :to="next" class="flex items-center">
				Next Project
				<span class="nav-arrow rotate-right ml-4"></span>
			</router-link>
		</div>
	</div>
</template>

<script>

// import Intro from '@/components/Intro.vue';

export default {
	props: ['prev', 'next']
}

</script>